import React from "react";
import { Outlet } from "react-router-dom";
import { I18nProvider } from "@client-app/i18n";
import { AdminProvider } from "./AdminContext";
import { AuthProvider } from "./AuthContext";
import { DialogProvider } from "./DialogContext";
import { OnboardingProvider } from "./OnboardingContext";
import { ToastProvider } from "./ToastContext";
import { BrandGroupProvider } from "./BrandGroupContext";
import { BrandPrototypeProvider } from "./BrandPrototypeContext";

export const AppProvider = () => {
    return (
        <I18nProvider>
            <ToastProvider>
                <DialogProvider>
                    <AuthProvider>
                        <OnboardingProvider>
                            <BrandGroupProvider>
                                <BrandPrototypeProvider>
                                    <AdminProvider>
                                        <Outlet />
                                    </AdminProvider>
                                </BrandPrototypeProvider>
                            </BrandGroupProvider>
                        </OnboardingProvider>
                    </AuthProvider>
                </DialogProvider>
            </ToastProvider>
        </I18nProvider>
    )
}

export const CloudAgentProvider: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
    return (
        <ToastProvider>
            <DialogProvider>
                {children ?? <Outlet />}
            </DialogProvider>
        </ToastProvider>
    )
}
